import { makeStyles } from '@material-ui/styles';
import { PartnerAd, PartnerAdPlacement, PartnerAdVariant } from '@skyslope/partnerships-sdk';
import {
  PartnerAdInternal,
  PartnershipAdCloseButton,
  PartnershipsErrorBoundary,
  useAd,
  PartnershipsFileMetadata,
  useOnDismissed,
} from '@skyslope/partnerships-sdk/react';
import React, { useCallback } from 'react';
import { IRootState } from '../store';
import { useSelector } from 'react-redux';
import { tokenInfo } from '../lib/token';

const useStyles = makeStyles({
  dsAdBox: {
    position: 'relative',
  },
});

export interface IDSAdProps {
  adVariant: PartnerAdVariant;
  id: string;
  imgProps?: React.ImgHTMLAttributes<HTMLImageElement>;
}

const useEnvelopeData = () => {
  return useSelector((state: IRootState) => state.envelope.envelope);
};

const DSAd: React.FC<IDSAdProps> = (props: IDSAdProps) => {
  const classes = useStyles();
  const envelope = useEnvelopeData();
  const formTypes = envelope?.documents
    .filter(document => document.metadata?.formType != null)
    .map(document => document.metadata.formType);

  const filterFn = useCallback((partnerAd: PartnerAd): boolean => {
    let showOnlyForFormTypes = partnerAd.metadata?.showOnlyForFormTypes;
    if (typeof showOnlyForFormTypes === 'string') {
      showOnlyForFormTypes = [showOnlyForFormTypes];
    }
    return (showOnlyForFormTypes as string[])?.some(formType => formTypes?.includes(formType)) ?? false;
  }, []);

  const { ad } = useAd({ variant: props.adVariant, placement: PartnerAdPlacement.DS3Signer, filterFn });
  const { dismissed, onDismissed } = useOnDismissed(props.id);

  const userMetadata: PartnershipsFileMetadata = {
    clientDetails: [
      {
        name: [envelope?.signer?.firstName, envelope?.signer?.middleName, envelope?.signer?.lastName]
          .filter(Boolean)
          .join(' '),
        email: `${tokenInfo?.Email ?? ''}`,
      },
    ],
    subscriberId: `${envelope?.metadata?.ownerSubscriberId}`,
  };

  if (ad == null || dismissed) {
    return null;
  }

  return (
    <PartnershipsErrorBoundary>
      <div className={classes.dsAdBox}>
        <PartnerAdInternal
          ad={ad}
          id={props.id}
          variant={props.adVariant}
          imgProps={props.imgProps}
          metadata={userMetadata}
          placement={PartnerAdPlacement.DS3Signer}
        />
        <PartnershipAdCloseButton onDismissed={onDismissed} />
      </div>
    </PartnershipsErrorBoundary>
  );
};

export default DSAd;
